import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import { decode, encode } from 'base-64';

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import ActionAdd from '../../store/action/TransmitterSetting/Add'
import ActionEdit from '../../store/action/TransmitterSetting/Edit'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGet from '../../store/action/TransmitterSetting/Fetch'
class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        'client-id': '',
        'division-id': '',
        'sender-id': '',
        'url-docker': '',
        'authorization': '',
        'user': '',
        'password': ''
      }),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    this.props.actionGetAllClient();
    if (this.props.actionType == IsEdit) {
      this.props.actionGetAllSender(this.props.item.get('client-id'));
      this.props.actionGetAllDivision(this.props.item.get('client-id'));
    }

  }

  handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);

    if (field === 'client-id') {
      this.setState({ client_id: value })
      this.props.actionGetAllSender(value);
      this.props.actionGetAllDivision(value)

    }

    if(field === 'division-id'){
      this.props.actionGetAllSender(formVal.get('client-id'),value);
    }
    this.setState({ form: formVal })
  }
  async handleSubmit(dispatch) {

    const form = this.state.form;

    if (form.get('sender-id') == '' || form.get('sender-id') == null || form.get('sender-id') == undefined) {
      this.setState({ error: "Sender cannot be empty!" });
      toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);

      return false;
    }

    if (form.get('url-docker') == '' || form.get('url-docker') == null || form.get('url-docker') == undefined) {
      this.setState({ error: "Base Url Cannot Be Empty !" });
      toast.error('Base Url Cannot Be Empty', toast.POSITION.TOP_RIGHT);

      return false;
    }

    if (form.get('user') == '' || form.get('user') == null || form.get('user') == undefined) {
      this.setState({ error: "User cannot be empty!" });
      toast.error('User cannot be empty!', toast.POSITION.TOP_RIGHT);

      return false;
    }

    if (form.get('password') == '' || form.get('password') == null || form.get('password') == undefined) {
      this.setState({ error: "Password cannot be empty!" });
      toast.error('Password cannot be empty!', toast.POSITION.TOP_RIGHT);

      return false;
    }
    switch (this.props.actionType) {
      case IsCreate:
        await this.SubmitNewData();
        break;
      case IsEdit:
        await this.SubmitEditData();
        break;
      default:
      // code block
    }


  }

  async SubmitNewData() {
    const form = this.state.form;
    var authorization = encode(form.get('user') + ":" + form.get('password'))
    //debugger
    var data =
    {
      'data':
      {
        'url-docker': form.get('url-docker'),
        'sender-id': form.get('sender-id'),
        'authorization': authorization
      }
    };

    var response = await this.props.actionAdd(data);
    if (response.ok) {
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  async SubmitEditData() {
    const form = this.state.form;
    var authorization = encode(form.get('user') + ":" + form.get('password'))
    var data =
    {
      'data': {
        'url-docker': form.get('url-docker'),
        'sender-id': form.get('sender-id'),
        'authorization': authorization
      }
    };

    var response = await this.props.actionEdit(data);
    if (response.ok) {
      toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      //toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  handleCancel() {
    this.props.handleCancelForm(false);
  }

  componentWillMount() {
    if (this.props.item != null || this.props.item !== undefined) {
      if ((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded) {
        var credential = decode(this.props.item.get('credential'))
        credential = credential.split(':')
        //debugger
        this.setState({
          form: fromJS({
            'url-docker': this.props.item.get('base-url'),
            'sender-id': this.props.item.get('sender-id'),
            'client-id': this.props.item.get('client-id'),
            'division-id': this.props.item.get('division-id'),
            'authorization': this.props.item.get('credential'),
            'user': credential[0],
            'password': credential[1]
          }),
          loadded: true,
          disabled: (this.props.actionType === IsView),
        })
      }
    }
  }

  render() {
    const { form, errors, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Client</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='client-id'
                value={form.get('client-id')}
                options={fromJS({
                  'source': this.props.clientall,
                  'value': 'client-id',
                  'label': 'client-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Client"
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Division</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='division-id'
                value={form.get('division-id')}
                options={fromJS({
                  'source': this.props.divisionall,
                  'value': 'division-id',
                  'label': 'division-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Division"
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Sender</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='sender-id'
                value={form.get('sender-id')}
                options={fromJS({
                  'source': this.props.senderall,
                  'value': 'sender-id',
                  'label': 'sender-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Sender"
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Url</span>
            <div className="col-sm-10">
              <TextInputField className="form-control"
                field={'url-docker'}
                value={form.get('url-docker')}
                onChange={(field, value) => this.handleChange(field, value)}
                placeholder="Url"
                disabled={disabled}
                hasError={errors.has('url-docker')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom ">
            <span className="col-sm-2">User</span>
            <div className="col-sm-10">
              <TextInputField className="form-control"
                field={'user'}
                value={form.get('user')}
                onChange={(field, value) => this.handleChange(field, value)}
                placeholder="user"
                disabled={disabled}
                hasError={errors.has('user')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom ">
            <span className="col-sm-2">Password</span>
            <div className="col-sm-10">
              <TextInputField className="form-control"
                field={'password'}
                value={form.get('password')}
                onChange={(field, value) => this.handleChange(field, value)}
                placeholder="password"
                disabled={disabled}
                hasError={errors.has('password')}
              />
            </div>
          </div>



          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
              <button type="button"
                className="btn btn-wide btn-danger"
                value="Cancel"
                onClick={this.handleCancel}>
                Cancel
              </button>
              <button type="button"
                className="btn btn-wide btn-success"
                onClick={this.handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(
  (state) => {
    return {
      clientall: state.user.clientall,
      senderall: state.user.senders,
      divisionall: state.user.divisionall,
      transmitter: state.user.gettransmitter
    }
  },
  dispatch => bindActionCreators({
    actionGet: ActionGet,
    actionAdd: ActionAdd,
    actionGetAllClient: ActionGetAllClient,
    actionGetAllDivision: ActionGetAllDivision,
    actionGetAllSender: ActionGetAllSender,
    actionEdit: ActionEdit,

  }, dispatch),
)(Form);